import React, { useEffect } from 'react';
import './PortfolioModal.css';

const PortfolioModal = ({ project, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  if (!project) return null;

  return (
    <div 
      id="portfolio-modal" 
      className="modal"
      onClick={(e) => {
        if (e.target.id === 'portfolio-modal') {
          onClose();
        }
      }}
    >
      <div className="modal-content">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <img id="modal-img" src={project.img} alt={project.title} />
        <h3 id="modal-title">{project.title}</h3>
        <a 
          id="modal-link" 
          href={project.link} 
          target="_blank" 
          rel="noopener noreferrer"
          className="cta-button"
        >
          Visiter le site
        </a>
      </div>
    </div>
  );
};

export default PortfolioModal;

